<template>
  <div class="edcity-add-school">
    <v-row>
      <v-col class="m-5 mb-0">
        <v-text-field
          v-model="form.school_code"
          :label="labelHeader('school_code')"
          required
        ></v-text-field>        
        <small style="color: #666666; font-size: 13px;">
          {{ $t("manage.by_edcity.add_update_school_teachers.expiry_date") }}
        </small>
        <br>
        <date-picker v-model="form.expiry_date"></date-picker>
        <br>
        <br>
        <v-text-field
          v-model="form.passcode"
          :label="labelHeader('passcode')"
          required
          type="password"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-file-input accept="text/csv" :label="labelHeader('upload_file')"
          :placeholder="labelHeader('upload_file_placeholder')" v-model="form.upload_file">
        </v-file-input>
      </v-col>
    </v-row>    
    <v-row>
      <v-col class="m-3">
        <v-btn class="primary" @click="addUpdateSchoolTeachersBySchoolCode()">{{ $t("manage.by_edcity.add_update_school_teachers.btn.import") }}</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card>
          {{ api.upload_status }}
          <br></br>
          {{ api.upload_message }}
          <br>
          {{ api.upload_error }}
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import moment, { duration } from 'moment';

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

import { api_edcity } from "@/services/dds/api_edcity";
const apiEdCity = new api_edcity(process.env.VUE_APP_BASE_URL);
export default {
  name: "CreateBookSlot",
  components: {
    DatePicker
  },
  data: function () {
    return {
      current: {
        username: null,
        uid: null,
        user_level: null,
        auth_token: null,
      },
      form: {
        school_code: 100000000008,
        school_year: null,
        expiry_date: "",
        passcode: null,
        upload_file: null,
      },
      api: {
        edcity_teachers: [],
        upload_status: "",
        upload_message: "",
        upload_error: "",
      },
    };
  },
  mounted: function () {
    var self = this;
    //self.current.school_id = self.$route.params.school_code;
    self.current.username = self.$store.state.user.username;
    self.current.uid = self.$store.state.user.uid;
    self.current.user_level = self.$store.state.user.user_level;
    self.current.auth_token = self.$store.state.user.auth_token;
  },  
  methods: {
    localeTranslate(){
      var self = this;
      if(self.$i18n.locale=='tc') return 'zh-tw';
      else return 'en';
    },
    labelHeader(label){
      var self = this;
      if(label=="school_code") return self.$t("manage.by_edcity.add_update_school_teachers.school_code");
      else if(label=="expiry_date") return self.$t("manage.by_edcity.add_update_school_teachers.expiry_date");
      else if(label=="passcode") return self.$t("manage.by_edcity.add_update_school_teachers.passcode");
      else if(label=="upload_file") return self.$t("manage.by_edcity.add_update_school_teachers.upload_file");
      else if(label=="upload_file_placeholder") return self.$t("manage.by_edcity.add_update_school_teachers.upload_file_placeholder");
    },
    addUpdateSchoolTeachersBySchoolCode(){
      var self = this;
      
      apiEdCity.addUpdateSchoolTeachersBySchoolCode(self.form.school_code, moment(self.form.expiry_date).format("YYYY-MM-DD"), self.form.passcode, self.form.upload_file)
      .then((response) =>{
        self.api.upload_status = response.status;
        if(response.status=="success"){
          self.$store.commit("showSnackBar", "Add/Updated Stduent List for " + self.form.school_code);
          self.api.upload_message = "";
          self.api.upload_error = "";
        }
        else if(response.status=="fail"){
          self.$store.commit("showSnackBar", response.error);
          self.api.upload_message = response.message;
          self.api.upload_error = response.error;
        }
      });      
      

    },
    goTo(school_id){
      var self = this;
      self.$router.push("/management/school/"+school_id);
    },
  },
  watch: {},
};
</script>

<style scoped lang="scss">
</style>